<template>
  <div>

    <!-- ── Stat Tiles ──────────────────────────────────────────── -->
    <div class="row mb-2 stat-tiles">

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100" style="border-left: 3px solid #2563eb !important;">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Informal Enrollees</p>
                <h4 class="mb-0 font-weight-bold text-primary">{{ totalInformal | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Basic Healthcare Provision Fund</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.bhcpf | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Equity Program (RivHealth)</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.sep | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/plans' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-secondary rounded-circle text-secondary">
                  <i class="fe fe-briefcase"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Voluntary Contributor (Rivcare)</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.c_rivcare | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                <i class="fe fe-briefcase"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Rivcare Basic</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.c_basic | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                <i class="fe fe-briefcase"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Rivcare Premium</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.c_premium | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                <i class="fe fe-briefcase"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Rivcare Premium Plus</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.c_plus | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-secondary rounded-circle text-secondary">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Dependents</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.dependants | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Governor Sim Free Healthcare Workers Scheme</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.governor | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div>
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">SCIMA Sickle Cell Program</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.scima | numeral(0, 0) }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/my-providers' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-activity"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Health Facilities</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.providers }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <router-link :to="{ path: '/list-records' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-success rounded-circle text-success">
                  <i class="fe fe-file-plus"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">All Encounters</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.encounters | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

    </div>

    <!-- ── Quick Links ────────────────────────────────────────────── -->
    <div class="d-flex mb-4" style="gap: 8px;">
      <router-link to="export-date">
        <button class="btn btn-sm btn-outline-secondary">
          <i class="fe fe-calendar mr-1"></i> Filter Enrollee Date
        </button>
      </router-link>
      <router-link to="export-provider">
        <button class="btn btn-sm btn-outline-secondary">
          <i class="fe fe-filter mr-1"></i> Filter Enrollee Provider
        </button>
      </router-link>
    </div>

    <!-- ── Charts ─────────────────────────────────────────────────── -->
    <div class="mb-4">
      <InformalLga />
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-bar-chart-2 text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Gender Distribution by LGA</h6>
      </div>
      <div class="card-body pt-0">
        <GenderbyLGA :sectors="sectors" />
      </div>
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-users text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Enrollee Distribution by Vulnerable Group</h6>
      </div>
      <div class="card-body pt-0">
        <VulnerableByLGA />
      </div>
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-map-pin text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Enrollee Distribution by LGA and Facility</h6>
      </div>
      <div class="card-body pt-0">
        <EnrolleebyLGAandFacility />
      </div>
    </div>

    <h6 class="font-weight-bold mb-3">
      <i class="fe fe-activity text-primary mr-2"></i> Category of Vulnerable Group Data
    </h6>
    <div class="row mb-4">
      <div class="col-md-6 mb-4">
        <BasicCategory />
      </div>
      <div class="col-md-6 mb-4">
        <genderCategory />
      </div>
    </div>

  </div>
</template>

<script>
  import InformalLga from "./informallga";
  import GenderbyLGA from "./GenderbyLGA";
  import BasicCategory from "./basicCategory";
  import genderCategory from "./genderCategory";
  import VulnerableByLGA from "./VulnerableByLGA";
  import EnrolleebyLGAandFacility from "./EnrolleebyLGAandFacility";

  export default {
    components: {
      genderCategory,
      InformalLga,
      GenderbyLGA,
      BasicCategory,
      VulnerableByLGA,
      EnrolleebyLGAandFacility,
    },

    data() {
      return {
        user: null,
        mydata: "",
        informaldata: "",
        auth_user: "",
        providers: "",
        clients: "",
        total_clients: "",
        claims: "",
        claim_status: "",
        offlineclients: [],
        sectors: [
          {
            name: "Basic Healthcare Provision Fund",
          },
          {
            name: "State Equity Program",
          },
          {
            name: "RIVCARE",
          },
        ],
        employees: "",
        plans: "",
        tpas: "",
      };
    },
    beforeMount() {
      this.$batchGet("/api/v1/auth/getinformalsectorenrollees/407465")
        .then((response) => {
          this.informaldata = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    computed: {
      totalInformal() {
        const d = this.informaldata || {};
        return (
          (d.bhcpf || 0) +
          (d.sep || 0) +
          (d.simjara || 0) +
          (d.dependants || 0) +
          (d.c_basic || 0) +
          (d.c_premium || 0) +
          (d.c_plus || 0) +
          (d.prof || 0) +
          (d.scima || 0) +
          (d.governor || 0) +
          (d.c_rivcare || 0)
        );
      },
    },

    methods: {},
    created() { },
  };
</script>
